<script setup lang="ts">
type Props = {
  opacity?: boolean;
  allowGrow?: boolean;
};

const { opacity = false, allowGrow = false } = defineProps<Props>();

const { userName } = useUserData();
</script>

<template>
  <ClientOnly>
    <div
      :class="[
        $style.container,
        { [$style.opacity]: opacity, [$style.grow]: allowGrow },
      ]"
    >
      <UserProfileDataCard :label="$t('account.username')">
        {{ userName }}
      </UserProfileDataCard>
    </div>
  </ClientOnly>
</template>

<style module lang="scss">
.container {
  @apply flex flex-col gap-3;
}

.grow {
  --card-grow: 1;
}

.opacity {
  @apply opacity-20 pointer-events-none select-none;
}
</style>
